import { fieldIsValid } from 'modules/Inquiry/Form/formConditions';
import { MEZZANINE_DESCRIPTION } from 'modules/Inquiry/Form/formFields';

export const validateMezzanineSection = (form) => fieldIsValid(MEZZANINE_DESCRIPTION)({ form });
